import * as Yup from 'yup';

const ERRORS = {
  LONG: 'Too long!',
  SHORT: 'Too short!',
  INVALID: 'Invalid!',
  REQUIRED: 'Required',
};

// Base validations (used for edit lead form)
export const editLeadValidations = {
  firstName: Yup.string().max(50, ERRORS.LONG).notRequired(),
  lastName: Yup.string().max(50, ERRORS.LONG).notRequired(),
  primaryPhoneNumber: Yup.string().max(14, ERRORS.LONG).notRequired(),
  secondaryPhoneNumber: Yup.string().max(14, ERRORS.LONG).notRequired(),
  email: Yup.string().email(ERRORS.INVALID).notRequired(),
  ssn: Yup.string().min(9, ERRORS.SHORT).max(11, ERRORS.LONG).notRequired(),
  primaryAddressCity: Yup.string().max(50, ERRORS.LONG).notRequired(),
  primaryAddressCounty: Yup.string().max(50, ERRORS.LONG).notRequired(),
  primaryAddressFipsCode: Yup.string().max(50, ERRORS.LONG).notRequired(),
  primaryAddressLineOne: Yup.string().max(50, ERRORS.LONG).notRequired(),
  primaryAddressLineTwo: Yup.string().max(50, ERRORS.LONG).notRequired(),
  primaryAddressState: Yup.string().max(2, ERRORS.LONG).notRequired(),
  primaryAddressZipCode: Yup.string().length(5, ERRORS.INVALID).notRequired(),
  secondaryAddressCity: Yup.string().max(50, ERRORS.LONG).notRequired(),
  secondaryAddressCounty: Yup.string().max(50, ERRORS.LONG).notRequired(),
  secondaryAddressFipsCode: Yup.string().max(50, ERRORS.LONG).notRequired(),
  secondaryAddressLineOne: Yup.string().max(50, ERRORS.LONG).notRequired(),
  secondaryAddressLineTwo: Yup.string().max(50, ERRORS.LONG).notRequired(),
  secondaryAddressState: Yup.string().max(2, ERRORS.LONG).notRequired(),
  secondaryAddressZipCode: Yup.string().length(5, ERRORS.INVALID).notRequired(),
  medicareNumber: Yup.string().length(11, ERRORS.INVALID).notRequired(),
};

// Validations used for create lead form.
export const createLeadValidations = {
  ...editLeadValidations,
  firstName: Yup.string().max(50, ERRORS.LONG).notRequired(),
  lastName: Yup.string().max(50, ERRORS.LONG).notRequired(),
  email: Yup.string().email(ERRORS.INVALID).notRequired(),
};

export const submitSaleValidations = {
  cmsId: Yup.string()
    .max(13, ERRORS.LONG)
    .min(10, ERRORS.SHORT)
    .matches(/[HESRhesr]\d{4}[-\s_]\d{3}([-\s_]\d{1,3})?/, 'Please enter a valid value.'),
  selectPlanType: Yup.string().min(2).required(ERRORS.REQUIRED),
  effectiveDate: Yup.string().required(ERRORS.REQUIRED),
  confirmEffectiveDate: Yup.string()
    .required()
    .test('match', 'Fields do not match', (value, testContext) => value === testContext.parent.effectiveDate),
  medigapPlanName: Yup.string().test('match', 'Required', (value, testContext) =>
    testContext.parent.selectPlanType === 'MEDIGAP' ? !!value : true
  ),
  monthlyPremium: Yup.string()
    .test('match', 'Required', (value, testContext) =>
      testContext.parent.selectPlanType === 'MEDIGAP' ? !!value : true
    )
    .test('lessThan1000', 'Monthly premium must be less than 1000', (value, testContext) =>
      testContext.parent.selectPlanType === 'MEDIGAP' ? parseFloat(value) < 1000 : true
    ),
  medigapCarrierName: Yup.string().test('match', 'Required', (value, testContext) =>
    testContext.parent.selectPlanType === 'MEDIGAP' ? !!value : true
  ),
};

export const createAgencyValidations = {
  firstName: Yup.string().min(2, ERRORS.SHORT).max(50, ERRORS.LONG).required(ERRORS.REQUIRED),
  lastName: Yup.string().min(2, ERRORS.SHORT).max(50, ERRORS.LONG).required(ERRORS.REQUIRED),
  email: Yup.string().email(ERRORS.INVALID).required(ERRORS.REQUIRED),
  agencyName: Yup.string().min(2, ERRORS.SHORT).max(50, ERRORS.LONG).required(ERRORS.REQUIRED),
};
